import React from 'react';
import { Palette, BookOpen, Repeat, ArrowUpRight } from 'lucide-react';

const VERTICALS = [
  { name: 'Hue', tagline: 'Design & Brand Identity', desc: 'Bespoke visual systems, logo suites and packaging that give brands an unforgettable personality.', icon: Palette, tint: '#49001B' },
  { name: 'Soul', tagline: 'Storytelling & Content', desc: 'Long-form campaigns, scripts and social content that make audiences feel — not just scroll.', icon: BookOpen, tint: '#c94b4b' },
  { name: 'Loop', tagline: 'Digital & Performance', desc: 'Data-led media buying, growth loops and analytics that turn attention into measurable outcomes.', icon: Repeat, tint: '#3c6e91' },
];

export default function Verticals() {
  return (
    <section id="verticals" className="relative py-20 md:py-28 bg-[#e5d4a8]">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12">
          <div>
            <div className="text-[12px] uppercase tracking-[0.22em] text-[#162028]/60 mb-4 flex items-center gap-2">
              <span className="h-px w-8 bg-[#49001B]" /> Our Verticals
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1] tracking-tight text-[#162028] max-w-3xl">
              Three specialised <span className="italic text-[#49001B]">studios,</span> one house.
            </h2>
          </div>
          <p className="text-[15px] leading-relaxed text-[#162028]/70 max-w-md">Tailored solutions for every kind of client — pick the vertical that matches your ambition, or blend all three.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {VERTICALS.map((v) => {
            const Icon = v.icon;
            return (
              <div key={v.name} className="group relative rounded-3xl bg-[#ede2c4] border border-[#162028]/10 p-8 md:p-9 hover:-translate-y-1 transition-transform duration-500 overflow-hidden">
                <div className="absolute -top-16 -right-16 h-48 w-48 rounded-full opacity-0 group-hover:opacity-20 transition-opacity duration-700" style={{ background: v.tint }} />
                <div className="relative flex items-center justify-between mb-10">
                  <div className="h-12 w-12 rounded-full flex items-center justify-center text-[#ede2c4]" style={{ background: v.tint }}>
                    <Icon size={20} strokeWidth={1.7} />
                  </div>
                  <ArrowUpRight size={20} className="text-[#162028]/40 group-hover:text-[#162028] group-hover:rotate-45 transition-all duration-300" />
                </div>
                <div className="relative">
                  <div className="font-serif-display text-5xl md:text-6xl leading-none text-[#162028] mb-1">{v.name}<span className="text-[#49001B]">.</span></div>
                  <div className="text-[12px] uppercase tracking-[0.22em] text-[#162028]/60 mb-6">{v.tagline}</div>
                  <p className="text-[14.5px] leading-relaxed text-[#162028]/75">{v.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
